// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Pulse = createIcon(
  <path
    clipRule="evenodd"
    d="M14.8651 7.94215L10.8949 18.7003C10.5511 19.6317 9.24693 19.6671 8.85313 18.7558L6.42876 13.1454H4.0001C3.50304 13.1454 3.1001 12.7425 3.1001 12.2454C3.1001 11.7484 3.50304 11.3454 4.0001 11.3454H6.88884C7.32767 11.3454 7.72452 11.6063 7.89859 12.0091L9.81171 16.4363L13.8905 5.38421C14.2544 4.39819 15.6615 4.43522 15.973 5.43903L17.806 11.3454H20.0001C20.4972 11.3454 20.9001 11.7484 20.9001 12.2454C20.9001 12.7425 20.4972 13.1454 20.0001 13.1454H17.2903C16.8083 13.1454 16.3825 12.8317 16.2397 12.3714L14.8651 7.94215Z"
    fillRule="evenodd"
  />,
);
